<template>
  <img
      style="width: 100%;"
      :src="picture_url">
</template>

<script>
const dict = {
  rccs_1p_jaws: { desc: "Jaws 1", picture_url: "jaws1" },
  doorbell: { desc: "Doorbell", picture_url: "Ring-Video-Doorbell-3" },
  doorbell_v3: { desc: "Doorbell", picture_url: "Ring-Video-Doorbell-3" },
  hp_cam_v1: { desc: "Ring Floodlight", picture_url: "floodlight-cam-clear" },
  jbox_v1: { desc: "Ring Elite", picture_url: "Ring-Video-Doorbell-Elite" },
  chime: { desc: "Chime", picture_url: "chime" },
  chime_v2: { desc: "Chime V2", picture_url: "chime_v2" },
  chime_v3: { desc: "Chime V3", picture_url: "chime_v2" },
  chime_pro: { desc: "Chime Pro", picture_url: "chime-pro" },
  chime_pro_v2: { desc: "Chime Pro V2", picture_url: "chime_v2" },
  doorbot: { desc: "Doorbot", picture_url: "doorbot" },
  doorbell_v4: {
    desc: "Ring Video Doorbell 2",
    picture_url: "cocoa_doorbell_v3",
  },
  cocoa_doorbell: {
    desc: "Cocoa Doorbell",
    picture_url: "cocoa_doorbell_v3",
  },
  cocoa_doorbell_v2: {
    desc: "Cocoa Doorbell V2",
    picture_url: "cocoa_doorbell_v3",
  },
  cocoa_doorbell_v3: {
    desc: "Cocoa Doorbell V3",
    picture_url: "cocoa_doorbell_v3",
  },
  stickup_cam_gourami: {
    desc: "Stickup Cam Gourami",
    picture_url: "stickup_cam_gourami",
  },
  stickup_cam_v4: {
    desc: "Spotlight Cam Battery",
    picture_url: "spotlight-cam-battery-clear",
  },
  spotlight_solar: {
    desc: "Spotlight Cam Solar Panel",
    picture_url: "spotlight-solar-clear-01",
  },
  base_station_v1: {
    desc: "Alarm Base Station",
    picture_url: "bundle_alarm_5_piece",
  },
  base_station_k1: {
    desc: "Ring Alarm Pro - Kilimanjaro",
    picture_url: "kilimanjaro",
  },
  halo_gateway: {
    desc: "Halo Gateway - Daredevil",
    picture_url: "halo_gateway",
  },
  lpd_v4: { desc: "Jellyfish", picture_url: "Ring-Video-Doorbell-Pro" },
  always_home_camera: { desc: "Zeus", picture_url: "zeus" },
  lpd_v3: { desc: "Ring Pro v3", picture_url: "Ring-Video-Doorbell-Pro" },
  hp_cam_v2: {
    desc: "Spotlight Cam (Wired/Mount)",
    picture_url: "spotlight-cam-mount-01",
  },
  lpd_v2: { desc: "Ring Pro v2", picture_url: "Ring-Video-Doorbell-Pro" },
  lpd_v1: { desc: "Ring Pro v1", picture_url: "Ring-Video-Doorbell-Pro" },
  stickup_cam: {
    desc: "Stick Up Cam Classic V1",
    picture_url: "Stick-Up-Cam-1-1",
  },
  stickup_cam_elite: {
    desc: "Stick Up Cam Wired",
    picture_url: "Stick-Up-Cam-Elite-Angled-2",
  },
  stickup_cam_mini: {
    desc: "Stick Up Cam Mini",
    picture_url: "Stick-Up-Cam-Elite-Angled-2",
  },
  stickup_cam_mini_v2: {
    desc: "Indoor Cam (Naboom)",
    picture_url: "Stick-Up-Cam-Elite-Angled-2",
  },
  onvif_camera: {
    desc: "Onvif Camera",
    picture_url: "Stick-Up-Cam-Elite-Angled-2",
  },
  stickup_cam_v3: {
    desc: "Stick Up Cam Classic V2",
    picture_url: "Stick-Up-Cam-1-1",
  },
  doorbell_v5: { desc: "Doorbell V5", picture_url: "cocoa_doorbell_v3" },
  stickup_cam_lunar: {
    desc: "Stick Up Cam Battery",
    picture_url: "Stick-Up-Cam-Battery-Angled-2",
  },
  doorbell_scallop: {
    desc: "Doorbell Scallop",
    picture_url: "doorbell-scallop",
  },
  doorbell_scallop_lite: {
    desc: "Doorbell Scallop Lite",
    picture_url: "doorbell-scallop-lite",
  },
  doorbell_oyster: {
    desc: "Doorbell Oyster",
    picture_url: "doorbell-scallop",
  },
  df_doorbell_clownfish: {
    desc: "Doorbell Clownfish",
    picture_url: "doorbell-scallop",
  },
  floodlight_v2: { desc: "floodlight v2", picture_url: "floodlight-cam-clear" },
  floodlight_pro: {
    desc: "floodlight pro",
    picture_url: "floodlight-cam-clear",
  },
  floodlight_poe_v1: {
    desc: "Floodlight W/ POE",
    picture_url: "floodlight-cam-clear",
  },
  spotlightw_v2: {
    desc: "spotlight wired v2",
    picture_url: "spotlight-wired-02",
  },
  spotlightw_poe_v1: {
    desc: "spotlight poe v1",
    picture_url: "spotlight-wired-02",
  },
  doorbell_portal: { desc: "Doorbell Portal", picture_url: "doorbell-portal" },
  doorbell_graham_cracker: {
    desc: "Doorbell Graham Cracker",
    picture_url: "cocoa_doorbell_v3",
  },
  cocoa_camera: { desc: "Cocoa Camera", picture_url: "cocoa_camera" },
  cocoa_camera_v2: { desc: "Sailfish", picture_url: "cocoa_camera" },
  stickup_cam_medusa: {
    desc: "Stick Up Cam Pro",
    picture_url: "stickup_cam_medusa",
  },
  stickup_cam_medusa_poe: {
    desc: "Stick Up Cam Pro POE",
    picture_url: "stickup_cam_medusa_poe",
  },
  stickup_cam_longfin: {
    desc: "Spotlight Cam Pro",
    picture_url: "stickup_cam_longfin",
  },
  stickup_cam_longfin_poe: {
    desc: "Spotlight Cam Pro POE",
    picture_url: "stickup_cam_longfin_poe",
  },

  cocoa_floodlight: {
    desc: "Cocoa Floodlight",
    picture_url: "floodlight-cam-clear",
  },
  cocoa_spotlight: {
    desc: "Cocoa Spotlight",
    picture_url: "cocoa_spotlight",
  },
  beams_bridge_v1: { desc: "Beams Bridge V1", picture_url: "beams_bridge" },
  beams_bridge_v2: { desc: "Beams Bridge V2", picture_url: "beams_bridge" },
  beams_c20_motion_sensor: {
    desc: "Smart Lighting Motion Sensor",
    picture_url: "beams_c20_motion_sensor",
  },
  beams_c20_motion_sensor_antenna: {
    desc: "Ring Mailbox Sensor",
    picture_url: "beams_c20_motion_sensor_antenna",
  },
  beams_c30_spotlight: {
    desc: "Smart Lighting Spotlight",
    picture_url: "beams_c30_spotlight",
  },
  beams_c40_steplight: {
    desc: "Smart Lighting Steplight",
    picture_url: "beams_c40_steplight",
  },
  beams_c41s_steplight: {
    desc: "Smart Lighting Solar Steplight",
    picture_url: "beams_c41s_steplight",
  },
  beams_c50_pathlight: {
    desc: "Smart Lighting Pathlight",
    picture_url: "beams_c50_pathlight",
  },
  beams_c50s_pathlight: {
    desc: "Smart Lighting Solar Pathlight",
    picture_url: "beams_c50s_pathlight",
  },
  beams_c3500_spotlight: {
    desc: "Smart Lighting Floodlight Battery",
    picture_url: "beams_c3500_spotlight",
  },
  beams_c3500s_floodlight: {
    desc: "Smart Lighting Solar Floodlight",
    picture_url: "beams_c3500s_floodlight",
  },
  beams_c4100s_wallpack: {
    desc: "Smart Lighting Wall Light Solar",
    picture_url: "beams_c4100s_wallpack",
  },
  beams_c5000_floodlight: {
    desc: "Smart Lighting Floodlight Wired",
    picture_url: "beams_c5000_floodlight",
  },
  beams_cp100_plug: {
    desc: "Outdoor Smart Plug",
    picture_url: "beams_cp100_plug",
  },
  beams_ct200_transformer: {
    desc: "Smart Lighting Transformer",
    picture_url: "beams_ct200_transformer",
  },
  beams_a19_bulb: {
    desc: "Smart Lighting LED Bulb A19",
    picture_url: "beams_a19_bulb",
  },
  beams_par38_bulb: {
    desc: "Smart Lighting LED Bulb Par38",
    picture_url: "beams_par38_bulb",
  },
  three_p_cam: {
    desc: "Third Party Cam",
    picture_url: "three_p_cam",
  },
  echo_laser: {
    desc: "Echo Laser",
    picture_url: "echo_laser",
  },
  intercom_handset_audio: {
    desc: "Ringtercom",
    picture_url: "intercom_handset_audio",
  },
  racp: {
    desc: "Ring Access Controller Pro",
    picture_url: "racp",
  },
  tracker_buddy: {
    desc: "Fetch",
    picture_url: "tracker_buddy",
  },
  vehicle_brody_v1: {
    desc: "Brody",
    picture_url: "vehicle_brody_v1",
  },
  stickup_cam_mini_ptz_v1: {
    desc: "Stickup Cam Mini Ptz V1",
    picture_url: "stickup_cam_mini_ptz_v1",
  },
  intercom_handset_virtual: {
    desc: "Ringtercom Virtual",
    picture_url: "intercom_handset_virtual",
  },
  sensor_bluejay_wsc: {
    desc: "Sensor Bluejay Wsc",
    picture_url: "bluejay",
  },
  sensor_bluejay_ws: {
    desc: "Sensor Bluejay Ws",
    picture_url: "bluejay",
  },
  sensor_bluejay_sc: {
    desc: "Sensor Bluejay Sc",
    picture_url: "bluejay",
  },
  sensor_bluejay_s: {
    desc: "Sensor Bluejay S",
    picture_url: "bluejay",
  },
};

export default {
  name: "DeviceImage",
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  computed: {
    picture_url() {
      let image_default_path =
        "/static/images/products/ring-device-default-image.png";
      if (this.device) {
        if (dict[this.device.type])
          return `/static/images/products/${
            dict[this.device.type].picture_url || "ring-device-default-image"
          }.png`;
        else return image_default_path;
      } else {
        return image_default_path;
      }
    },
  },
};
</script>
